<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
const props = defineProps({
  // Lottie
  src: { type: String, required: true }, // JSON or .lottie url
  renderer: { type: String, default: "svg" },
  loop: { type: Boolean, default: true },
  autoplay: { type: Boolean, default: true }, // for LCP: start immediately
});

useHead(
  {
    link: [{ rel: "preload", as: "fetch", href: props.src, type: "application/json" }],
  },
  { mode: "server" }
);

const container = ref(null);
let anim;

onMounted(async () => {
  // Replace poster with Lottie as soon as we can (no visibility gating for LCP)
  const lottie = (await import("lottie-web")).default;
  anim = lottie.loadAnimation({
    container: container.value,
    renderer: props.renderer,
    loop: props.loop,
    autoplay: props.autoplay,
    path: props.src,
    rendererSettings: {
      progressiveLoad: true, // stream large SVG assets
      hideOnTransparent: true,
    },
  });
});

onBeforeUnmount(() => anim?.destroy?.());
</script>

<template>
  <!-- SSR paints this immediately; prevents CLS -->
  <div ref="container"></div>
</template>
